import Box from "@ui-kit/layout/Box/Box.web";
import type { BaseItemGroupDisplayProps } from "../ItemGroup.props";
import ItemGroupDisplay from "../ItemGroupDisplay/ItemGroupDisplay.web";
import ItemGroupSkeleton from "../ItemGroupSkeleton/ItemGroupSkeleton.web";

export default function ItemGroupGiftCard({
  quantity,
  name,
  eventService,
  ...rest
}: {
  quantity: number;
  name: string;
} & Omit<BaseItemGroupDisplayProps, "name">): JSX.Element {
  return (
    <Box width="100%">
      <ItemGroupDisplay
        eventService={eventService}
        {...rest}
        name={name}
        quantity={quantity}
        isGiftCard
      />
    </Box>
  );
}

ItemGroupGiftCard.Skeleton = ItemGroupSkeleton;
